<template>
  <div>
    <div class="sl_users__table" :class="{'modal_table' : reduceColumnSize}">
      <table v-show="value && value.length">
        <thead>
        <tr v-if="withOptions">
          <th></th>
          <th>
            <v-icon size="18" color="info">edit</v-icon>
          </th>
          <th>
            <v-icon size="18" color="error">delete_forever</v-icon>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(user, index) in value">
          <td>
            <div class="sl_users__table--user">
              <span>{{ user.name }}</span>
              <a @click="remove(index)">
                <v-icon color='error' size='14'>close</v-icon>
              </a>
            </div>
          </td>
          <td v-if="withOptions">
            <v-checkbox v-model='user.pivot.edit' hide-details></v-checkbox>
          </td>
          <td v-if="withOptions">
            <v-checkbox v-model='user.pivot.delete' hide-details></v-checkbox>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <v-select
        ref="input"
        multiple
        v-model="selected"
        :items="availableUsers"
        item-text="name"
        return-object
        :label="label"
        chips
        deletable-chips
    />
    <v-btn @click="addUser" class="mt-0 mb-5" color="info" small block>Add</v-btn>
  </div>
</template>

<script>
  export default {
    name: 'SlExtendedSelect',
    data() {
      return {
        error: '',
        selected: []
      }
    },
    props: {
      'value': {
        type: Array,
        default() {
          return []
        }
      },
      'data': {
        type: Array,
        default: () => {
          return []
        }
      },
      'label': {
        type: String,
        default: 'Select'
      },
      'withOptions': {
        type: Boolean,
        default: true
      },
      'reduceColumnSize': {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value: {
        handler(newValue) {
          this.$emit('updateUsersList', newValue)
        },
        deep: true
      },
    },
    computed: {
      availableUsers() {
        return this.data.filter(item => !this.value.some(user => user.user_id === item.user_id))
      }
    },
    methods: {
      addUser() {
        let users = this.value

        this.selected.forEach(item => {
          if (!users.some(user => user.id == item.id)) {
            users.push(this.withOptions ? {...item, pivot: {edit: 0, delete: 0,}} : item)
          }
        })

        this.$emit('input', users)
        this.selected = []
      },
      remove(index) {
        let users = this.value

        users.splice(index, 1)

        this.$emit('input', users)
      }
    }
  }
</script>

<style scoped lang="stylus">
.modal
  &_table
    table
      td
        padding 5px 15px

</style>
